import { Box, Flex } from '@rebass/grid';

import { Text, Image } from 'app/shared/ui';

import { InsuranceCallButtonLink, TarifOnlineLink } from '../../contants';
import { InformationItem } from '../components/InformationItem';

import * as Styled from './InsuranceHubHeader.css';

export const InsuranceHubHeader = (): JSX.Element => {
  return (
    <Styled.InsuranceHubHeaderWrapper>
      <Flex flexDirection="column" alignItems="center" px={['20px', 0]}>
        <Styled.HeaderText>
          Der passende Versicherungsschutz für dich
        </Styled.HeaderText>
        <Text
          fontSize="16px"
          lineHeight="23px"
          fontWeight="500"
          mt={['16px', '10px']}
        >
          Rundum sicher mit deiner Kfz-Versicherung.
        </Text>
      </Flex>
      <Flex
        width="100%"
        justifyContent="center"
        flexDirection={['column', 'row']}
        mt={['24px', '0']}
      >
        <Flex
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          px={['20px', 0]}
        >
          <InformationItem message="Rundum sicher mit der Kfz-Versicherung von heycar und Allianz" />
          <InformationItem message="Einfach abschließbar" />
          <InformationItem message="Maßgeschneiderter Schutz" />
        </Flex>
        <Box>
          <Image
            src="/assets/insuranceHub/insurance_KV.png"
            alt=""
            width={380}
            height={266}
          />
        </Box>
      </Flex>
      <Flex justifyContent="center" alignItems="center" height="76px">
        <Styled.InsuranceHubHeaderCTAWrapper>
          <Flex flexDirection={['row', 'column']}>
            <Text
              fontSize="14px"
              lineHeight="20px"
              mr={['3px', '15px']}
              mb={['8px', '0px']}
            >
              Mehr Informationen unter <b>030/20164026</b>
            </Text>
            {/* This comment will open after the Allianz contract approved */}
            {/* 
            <Text
              fontSize="14px"
              lineHeight="20px"
              mr={['0', '15px']}
              mb={['8px', '0px']}
            >
              unter <b>030/20164026</b>
            </Text> */}
          </Flex>
          <Styled.AnrufenButton
            variant="secondary"
            target="_self"
            to={InsuranceCallButtonLink}
          >
            Jetzt Versicherungspartner anrufen
          </Styled.AnrufenButton>
          <Text fontSize="14px" lineHeight="20px" mb={['8px', '0px']}>
            oder
          </Text>
          <Styled.TarifOnlineButton
            variant="primary"
            target="_blank"
            to={TarifOnlineLink}
          >
            Tarif online berechnen
          </Styled.TarifOnlineButton>
        </Styled.InsuranceHubHeaderCTAWrapper>
      </Flex>
      <Styled.PartnerShipwrapper>
        <Text
          fontSize="12px"
          lineHeight="18px"
          mt={['16px', '0px']}
          mb={['6px', '0px']}
        >
          In Partnerschaft mit
        </Text>
        <Flex mb={['10px', '0px']}>
          <Image
            src="/assets/insuranceHub/ww_financing.png"
            alt=""
            width={181}
            height={19}
            ml={['0px', '32px']}
          />
          <Image
            src="/assets/allianz/allianz-logo.svg"
            alt=""
            width={81}
            height={20}
            ml="32px"
          />
        </Flex>
      </Styled.PartnerShipwrapper>
    </Styled.InsuranceHubHeaderWrapper>
  );
};
